import React from 'react';
import { Card, Carousel, Row, Col, Typography } from 'antd';
import {
  SolutionOutlined,
  FileProtectOutlined,
  LineChartOutlined,
  BarChartOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from '@ant-design/icons';
import { useWindowDimensions } from '../utils/hooks';
import OtherStats from './Stats/OtherStats';
import { connect } from 'react-redux';
import { State, States } from 'sigt';
import { ChartCard } from 'ant-design-pro/lib/Charts';
import '../assets/css/components/Welcome.css';
import SedematStats from './Stats/SedematStats';
import bomberos1 from '../assets/images/Bomberos1.jpeg';
import bomberos2 from '../assets/images/Bomberos2.jpeg';
import bomberos3 from '../assets/images/Bomberos3.jpeg';
import bomberos4 from '../assets/images/Bomberos4.jpeg';
import timbres from '../assets/images/timbres.png';
import dosPorCien from '../assets/images/2x100.png';
import minerales from '../assets/images/minerales.png';
import bomberos from '../assets/images/bomberos.png';
import info1 from '../assets/images/info1.png';
import info2 from '../assets/images/info2.png';

const { Text, Title, Paragraph } = Typography;

const Welcome: React.FC<WelcomeProps> = ({ thm, auth, stats }) => {
  const { width } = useWindowDimensions();

  const otherStats = [1, 3, 5, 7, 9, 11, 13, 15, 20, 43, 17, 18, 19];
  const sedematStats = [24, 26, 27, 35, 37, 42, 55, 90];
  const seeingStats = [...otherStats, ...sedematStats];

  const isUsuario = auth.user?.tipoUsuario === 4;
  const canSeeStats = seeingStats.find((id) => auth.user?.institucion?.cargo?.id === id);
  const isSedemat = auth.user?.institucion?.id === 9;

  return (
    <Card
      style={{ height: '100%' }}
      cover={
        auth.user?.tipoUsuario === 4 || !canSeeStats ? <div id='cover' style={{ height: '0vh', padding: '0%' }}></div> : undefined
      }
      title={!isUsuario && auth.user && canSeeStats ? 'Estadísticas' : undefined}
      headStyle={
        !isUsuario ? { backgroundColor: thm.primaryColor, padding: width < 992 ? '0 10px' : '0 20px', color: 'white' } : undefined
      }
      bodyStyle={{
        height: 'calc(100% - 20px)',
        overflowY: 'scroll',
        overflowX: 'hidden',
        border: '1px solid #f0f0f0',
        position: 'relative',
      }}
    >
      {!isUsuario && auth.user && canSeeStats && !isSedemat && <OtherStats />}
      {!isUsuario && auth.user && canSeeStats && isSedemat && <SedematStats />}
      {/* {(isUsuario || !auth.user || !canSeeStats) && (
        <Carousel dotPosition='top' autoplay autoplaySpeed={10000}>
          <div>
            <div className='content2' style={{ marginTop: width < 600 ? '4%' : '2%' }}>
              <Row>
                <Col xl={12} xs={24}>
                  <img
                    style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    src={timbres}
                    alt='asd'
                    width={'95%'}
                    height={'100%'}
                  />
                </Col>
                <Col xl={12} xs={24}>
                  <img
                    style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    src={bomberos}
                    alt='asd'
                    width={'95%'}
                    height={'100%'}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div>
            <div className='content2' style={{ marginTop: width < 600 ? '4%' : '2%' }}>
              <Row>
                <Col xl={12} xs={24}>
                  <img
                    style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    src={dosPorCien}
                    alt='asd'
                    width={'95%'}
                    height={'100%'}
                  />
                </Col>
                <Col xl={12} xs={24}>
                  <img
                    style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    src={minerales}
                    alt='asd'
                    width={'95%'}
                    height={'100%'}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Carousel>
      )} */}
      {(isUsuario || !auth.user || !canSeeStats) && (
        <Carousel dotPosition='top' autoplay autoplaySpeed={10000} style={{ marginTop: '1%' }}>
          {/* <div>
            <div className='content' style={{ marginTop: width < 600 ? '7%' : '4%' }}>
              <Row>
                <Col xl={12} xs={24}>
                  <img style={{display: 'block', marginLeft: 'auto', marginRight: 'none', width: '95%'}} 
                    src={info1} alt='asd' width={'100%'} height={'100%'} />
                </Col>
                <Col xl={12} xs={24}>
                  <img style={{display: 'block', marginLeft: 'auto', marginRight: 'none', width: '95%'}} 
                    src={info2} alt='asd' width={'100%'} height={'100%'} />
                </Col>
                <Col xl={6} xs={24}>
                  <img style={{display: 'block', marginLeft: 'auto', marginRight: 'none', width: '95%'}} 
                    src={bomberos3} alt='asd' width={'100%'} height={'100%'} />
                </Col>
                <Col xl={6} xs={24}>
                  <img style={{display: 'block', marginLeft: 'auto', marginRight: 'none', width: '95%'}} 
                    src={bomberos4} alt='asd' width={'100%'} height={'100%'} />
                </Col>
              </Row>
            </div>
          </div> */}
          <div>
            <div className='content' style={{ marginTop: width < 600 ? '7%' : '4%' }}>
              <Row>
                <Col span={24}>
                  <Title style={{ textAlign: 'center' }} level={4}>
                    Trámites <FileProtectOutlined />
                  </Title>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Paragraph>
                    En la barra de navegación ubicada en la parte izquierda encontrarás la sección de {' '}
                    <Text strong>Liquidación de impuestos</Text> donde podrás solicitar los timbres fiscales y las tasas requeridas, además podrás:
                    <ul>
                      <li>Visualizar todos los timbres fiscales liquidados haciendo clic en Bandejas – timbres fiscales y/o comprobantes.</li>
                      <li>Conocer el estado en el que se encuentra tu trámite.</li>
                    </ul>
                  </Paragraph>
                </Col>
              </Row>
            </div>
          </div>
          <div>
            <div className='content' style={{ marginTop: width < 600 ? '7%' : '4%' }}>
              <Row>
                <Col span={24}>
                  <Title style={{ textAlign: 'center' }} level={4}>
                    Control Tributario <SolutionOutlined />
                  </Title>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Paragraph>
                   En la parte izquierda podrás visualizar y descargar:
                   <ul>
                      <li>Comprobante de registro</li>
                      <li>Libro de control de timbres</li>
                      <li>Solvencias</li>
                    </ul>
                  </Paragraph>
                </Col>
              </Row>
            </div>
          </div>
          <div>
            <div className='content' style={{ marginTop: width < 600 ? '7%' : '4%' }}>
              <Row>
                <Col span={24}>
                  <Title style={{ textAlign: 'center' }} level={4}>
                    Tus Estadísticas <LineChartOutlined />
                  </Title>
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: 10 }}>
                <Col xl={8} xs={24}>
                  <ChartCard
                    title='Total de trámites realizados'
                    total={stats?.totalCount || 'N/A'}
                    avatar={width > 1360 ? <BarChartOutlined style={{ width: 30, height: 30 }} className='bigicon' /> : undefined}
                  />
                </Col>
                <Col xl={8} xs={24}>
                  <ChartCard
                    title='Total de trámites completados'
                    total={stats?.approvedCount || 'N/A'}
                    avatar={
                      width > 1360 ? (
                        <CheckCircleFilled style={{ width: 30, height: 30, color: '#92CD20' }} className='bigicon' />
                      ) : undefined
                    }
                  />
                </Col>
                <Col xl={8} xs={24}>
                  <ChartCard
                    title='Total de trámites rechazados'
                    total={stats?.rejectedCount || 'N/A'}
                    avatar={
                      width > 1360 ? (
                        <CloseCircleFilled style={{ width: 30, height: 30, color: '#E1422E' }} className='bigicon' />
                      ) : undefined
                    }
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Carousel>
      )}
    </Card>
  );
};

const mapStateToProps = (state: State) => ({ thm: state.thm, auth: state.auth, stats: state.st.stats });

export default connect(mapStateToProps)(Welcome);

interface WelcomeProps {
  thm: States.ThemeColors;
  auth: States.Auth;
  stats: States.Stats['stats'];
}
